import { Record } from 'immutable';
import { schema } from 'normalizr';

export const RelayControllerFirmwareVersion = new Record({
  id: undefined,
  version: undefined,
  release_notes: undefined,
  obsolete: undefined,
  upgrade_file: undefined,
  reports_radio_type: undefined,
  supports_negative_schedule_offsets: undefined,
  supports_v2_protocol: undefined,
  supports_relay_monitor: undefined,
  in_testing: undefined,
  supports_day_of_week_schedules: undefined,
  schedules_per_relay: undefined,
  supports_sun_offsets_per_schedule: undefined,
  measures_power_consumption_in_watts: undefined,
  // Hardware models this image runs on, derived from the version and sent
  // read-only. Empty when the rule matched nothing — unknown compatibility,
  // not "none". A Record silently drops keys it doesn't list, so this must
  // stay here for the picker's model guard to see the wire value at all.
  compatible_model_ids: undefined,
});

export const relayControllerFirmwareVersionSchema = new schema.Entity('relayControllerFirmwareVersions');

// for reading in nested models, object with { field: schema }
// relayControllerFirmwareVersionSchema.define({  });
